export function debounce(callback, options) {
  let timeoutID
  let lastExec = 0

  if (options.noTrailing === true) {
    options.debounceMode = callback
    // eslint-disable-next-line no-param-reassign
    callback = options.noTrailing
    options.noTrailing = undefined
  }

  function wrapper() {
    const self = this
    const elapsed = Number(new Date()) - lastExec
    // eslint-disable-next-line prefer-rest-params
    const args = arguments

    function exec() {
      lastExec = Number(new Date())
      callback.apply(self, args)
    }

    function clear() {
      timeoutID = undefined
    }

    if (options.debounceMode && !timeoutID) {
      exec()
    }
    if (timeoutID) {
      clearTimeout(timeoutID)
    }

    if (options.debounceMode === undefined && elapsed > options.delay) {
      exec()
    } else if (options.noTrailing !== true) {
      timeoutID = setTimeout(
        options.debounceMode ? clear : exec,
        options.debounceMode === undefined ? options.delay - elapsed : options.delay
      )
    }
  }
  return wrapper
}
